import React, { Fragment, useState, useEffect } from "react";
import { Facebook, Linkedin, Twitter } from "react-feather";
import { Form, FormGroup, Input, Label, Row, Col,Button } from "reactstrap";
import { Btn, H4, P, H6, Image } from "../../../AbstractElements";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Logo from "../../../assets/images/logo/logo.png";
import logoDark from "../../../assets/images/logo/logo_dark.png";
import { useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import RequiredField, {
  FirstName,
  LastName,
  BirthDate,
  Age,
  MobileNo,
} from "../../../Constant";
import { useForm, Controller } from "react-hook-form";
import { PatientRegistration } from "../../../apiController";

const RegisterFrom = ({ logoClassMain }) => {
  const [togglePassword, setTogglePassword] = useState(false);
  const [toggleConfirmPassword, setToggleConfirmPassword] = useState(false);

  const navigate = useNavigate()

  const {
    control,
    handleSubmit,
    watch,
    register,
    formState: { errors },
    reset,
    setValue,
  } = useForm();

  const [age, setAge] = useState("");

  const dob = watch("birthday");

  const [isSubmitting, setIsSubmitting] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");

  console.log(type);

  useEffect(() => {
    if (dob) {
      const dobDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - dobDate.getFullYear();
      const monthDiff = today.getMonth() - dobDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < dobDate.getDate())
      ) {
        age--;
      }
      setAge(age);
      setValue("age", age);
    }
  }, [dob, setValue]);

  const onSubmit = (data) => {
    console.log(data);

    const formData = {
      first_name: data.firstName,
      surname: data.lastname,
      phone: data.phone,
      age: data.age,
      dob: data.birthday,
      gender: data.gender,
    };

    console.log(formData);
    registerPatient(formData)
  };

  const registerPatient = async (formData) => {
    setIsSubmitting(true);
    try {
      const response = await PatientRegistration(formData);
      if (response.status === true) {
        toast.success("Created Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      reset();
      setIsSubmitting(false);
      navigate(`${process.env.PUBLIC_URL}/login`)
    }
  };
  return (
    <Fragment>
      <div className="login-card">
        <div>
          {/* <div>
            <Link className={`logo ${logoClassMain ? logoClassMain : ''}`} to={process.env.PUBLIC_URL}>
              <Image attrImage={{ className: 'img-fluid w-50 for-light', src: logoWhite, alt: 'loginpage' }} />
            </Link>
          </div> */}
          {/* <div>
            <Link className={`logo ${logoClassMain ? logoClassMain : ''}`} to={process.env.PUBLIC_URL}>
              <Image attrImage={{ className: 'img-fluid for-light', src: logoWhite, alt: 'looginpage' }} />
              <Image attrImage={{ className: 'img-fluid for-dark', src: logoDark, alt: 'looginpage' }} />
            </Link>
          </div> */}
          <div className="login-main">
            <Form
              className="theme-form login-form"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="d-flex justify-content-center">
                <Image
                  attrImage={{
                    className: " img-fluid w-50 for-light",
                    src: Logo,
                    alt: "looginpage",
                  }}
                />
              </div>
              {(type === "organisation" && (
                <H4>Create your Organisation account</H4>
              )) ||
                (type === "individual" && <H4>Create your account</H4>)}
              <P>Enter your personal details to create account</P>
              <FormGroup className="mb-3">
                <Label htmlFor="fname">{FirstName}</Label>
                <input
                  className={`form-control ${errors.firstName && "is-invalid"}`}
                  id="fname"
                  type="text"
                  name="firstname"
                  {...register("firstName", { required: false })}
                />
                <span className="text-danger">
                  {errors.firstName && "First name is required"}
                </span>
              </FormGroup>
              <FormGroup className="mb-3">
                <Label htmlFor="lname">{LastName}</Label>
                <input
                  className={`form-control ${errors.lastname && "is-invalid"}`}
                  id="lname"
                  type="text"
                  name="lastname"
                  {...register("lastname", { required: false })}
                />
                <span className="text-danger">
                  {errors.lastname && "Last name is required"}
                </span>
              </FormGroup>
              <FormGroup className="mb-3">
                <Label htmlFor="mobilenumber">{MobileNo}</Label>
                <input
                  className={`form-control ${errors.age && "is-invalid"}`}
                  id="phone"
                  type="number"
                  name="phone"
                  {...register("phone", { required: false })}
                />
                <span className="text-danger">
                  {errors.age && "Age is required"}
                </span>
              </FormGroup>
              <FormGroup className="mb-3">
                <Label htmlFor="Bdate">{BirthDate}</Label>
                <Controller
                  control={control}
                  name="birthday"
                  render={({ field }) => (
                    <input
                      {...field}
                      className={`form-control ${
                        errors.birthday && "is-invalid"
                      }`}
                      id="Bdate"
                      type="date"
                      max={new Date().toISOString().split("T")[0]} // Ensure max date is today
                    />
                  )}
                />
                <span className="text-danger">
                  {errors.birthday && "Birth Date is required"}
                </span>
              </FormGroup>
              <FormGroup className="mb-3">
                <Label htmlFor="age">{Age}</Label>
                <input
                  className={`form-control ${errors.age && "is-invalid"}`}
                  id="age"
                  type="number"
                  name="age"
                  value={age}
                  disabled
                />
                <span className="text-danger">
                  {errors.age && "Age is required"}
                </span>
              </FormGroup>
              {/* <FormGroup>
                    <Label htmlFor="gender">Gender</Label>
                    <div className="d-flex gap-3">
                      <div className="custom-control custom-radio">
                        <Controller
                          name="gender"
                          control={control}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <>
                              <Input
                                className="custom-control-input"
                                id="male"
                                type="radio"
                                onChange={() => field.onChange("male")}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="male"
                              >
                                Male
                              </Label>
                            </>
                          )}
                        />
                      </div>
                      <div className="custom-control custom-radio">
                        <Controller
                          name="gender"
                          control={control}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <>
                              <Input
                                className="custom-control-input"
                                id="female"
                                type="radio"
                                onChange={() => field.onChange("female")}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="female"
                              >
                                Female
                              </Label>
                            </>
                          )}
                        />
                      </div>
                    </div>
                  </FormGroup> */}
              <FormGroup>
                <Label htmlFor="gender">Gender</Label>
                <div className="d-flex gap-3">
                  <div className="custom-control custom-radio">
                    <Controller
                      name="gender"
                      control={control}
                      rules={{ required: false }}
                      render={({ field }) => (
                        <>
                          <input
                            className="custom-control-input"
                            id="male"
                            type="radio"
                            value="male"
                            checked={field.value === "male"}
                            onChange={() => field.onChange("male")}
                          />
                          <Label
                            className="custom-control-label"
                            htmlFor="male"
                          >
                            Male
                          </Label>
                        </>
                      )}
                    />
                  </div>
                  <div className="custom-control custom-radio">
                    <Controller
                      name="gender"
                      control={control}
                      rules={{ required: false }}
                      render={({ field }) => (
                        <>
                          <input
                            className="custom-control-input"
                            id="female"
                            type="radio"
                            value="female"
                            checked={field.value === "female"}
                            onChange={() => field.onChange("female")}
                          />
                          <Label
                            className="custom-control-label"
                            htmlFor="female"
                          >
                            Female
                          </Label>
                        </>
                      )}
                    />
                  </div>
                </div>
              </FormGroup>

              {/* <FormGroup>
                <Label className='col-form-label m-0 pt-0'>Your Name</Label>
                <Row className='g-2'>
                  <Col xs='6'>
                    <Input className='form-control' type='text' required='' placeholder='Fist Name' />
                  </Col>
                  <Col xs='6'>
                    <Input className='form-control' type='email' required='' placeholder='Last Name' />
                  </Col>
                </Row>
              </FormGroup>
              <FormGroup>
                <Label className='col-form-label m-0 pt-0'>Mobile Number</Label>     
                    <Input className='form-control' type='text' required placeholder='Mobile Number' minLength={10} max={10} min={10} />
              </FormGroup>
              { type === 'organisation' && <FormGroup>
                <Label className='col-form-label m-0 pt-0'>Dental Organisation Name</Label>     
                    <Input className='form-control' type='text' required placeholder='Your Dental Organisation Name' />
              </FormGroup> 
              || 
              type === 'individual' &&
              <FormGroup>
                <Label className='col-form-label m-0 pt-0'>DOB</Label>     
                    <Input className='form-control' type='date' required placeholder='Date of Birth' />
              </FormGroup>} */}
              {/* <FormGroup>
                <Label className='col-form-label m-0 pt-0'>Email Address</Label>
                <Input className='form-control' type='email' placeholder='Test@gmail.com' pattern='[a-zA-Z0-9.]{5,}@[a-z]+\.[a-z]{2,3}' />
              </FormGroup> */}
              {/* <FormGroup className='position-relative'>
                <Label className='col-form-label m-0 pt-0'>Password</Label>
                <div className='position-relative'>
                  <Input className='form-control' type={togglePassword ? 'text' : 'password'} name='login[password]' required placeholder='*********' />
                  <div className='show-hide' onClick={() => setTogglePassword(!togglePassword)}>
                    <span className={togglePassword ? '' : 'show'}></span>
                  </div>
                </div>
              </FormGroup>
              <FormGroup className='position-relative'>
                <Label className='col-form-label m-0 pt-0'>Confirm Password</Label>
                <div className='position-relative'>
                  <Input className='form-control' type={toggleConfirmPassword ? 'text' : 'password'} name='login[password]' required placeholder='*********' />
                  <div className='show-hide' onClick={() => setToggleConfirmPassword(!toggleConfirmPassword)}>
                    <span className={toggleConfirmPassword ? '' : 'show'}></span>
                  </div>
                </div>
              </FormGroup> */}
              {/* <FormGroup className='m-0'>
                <div className='checkbox'>
                  <Input id='checkbox1' type='checkbox' />
                  <Label className='text-muted' for='checkbox1'>
                    Agree with <span>Privacy Policy</span>
                  </Label>
                </div>
              </FormGroup> */}
              <FormGroup>

              <Button
                      type="submit"
                      color="primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </Button>
                {/* <Btn
                  attrBtn={{
                    className: "d-block w-100",
                    color: "primary",
                    type: "submit",
                  }}
                >
                  Create Account
                </Btn> */}
              </FormGroup>
              {/* <div className='login-social-title'>
                <H6 attrH6={{ className: 'text-muted or mt-4' }}>Or Sign up with</H6>
              </div>
              <div className='social my-4 '>
                <div className='btn-showcase'>
                  <a className='btn btn-light' href='https://www.linkedin.com/login' rel='noreferrer' target='_blank'>
                    <Linkedin className='txt-linkedin' /> LinkedIn
                  </a>
                  <a className='btn btn-light' href='https://twitter.com/login?lang=en' rel='noreferrer' target='_blank'>
                    <Twitter className='txt-twitter' />
                    twitter
                  </a>
                  <a className='btn btn-light' href='https://www.facebook.com/' rel='noreferrer' target='_blank'>
                    <Facebook className='txt-fb' />
                    facebook
                  </a>
                </div>
              </div> */}
              <P attrPara={{ className: "mb-0 text-start" }}>
                Already have an account?
                <Link className="ms-2" to={`${process.env.PUBLIC_URL}/login`}>
                  Sign in
                </Link>
              </P>
            </Form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default RegisterFrom;
